var _a;
import { canUseDom as isBrowser } from "../../can-use-dom";
import { CloudPlatform } from "./enums";
import { isSupportWebp, getDpr } from "./utils";
var options = {
    isSupportWebp: true,
    dpr: 2,
    rem2px: isBrowser && window.rem2px
        ? window.rem2px
        : function (n) { return 100 * Number(n); },
    cdnConfig: (_a = {},
        _a[CloudPlatform.CloudFront] = [
            // 印尼、马来
            "cstatic.akulaku.net",
            "drxf4sxe82fjt.cloudfront.net",
            "d12x8ezp3au6m3.cloudfront.net",
            "d12x8ezp3au6m3.akulaku.net",
            // 重构（可能只有业务工程内部图片用到）
            "ec-cstatic.akulaku.net",
            // 欧洲
            "cstatic.wisecartapp.com",
            "static.wisecartapp.com",
            "bimg.wisecartapp.com",
            "d12x8ezp3au6m3.wisecartapp.com",
            // 欧洲线上使用的腾讯云平台时，暂不支持webp，暂时屏蔽
            // "ec-cos-user-public-read-prod-1305903507.cos.eu-frankfurt.myqcloud.com",
        ],
        _a[CloudPlatform.AlibabaCloud] = [
            // 印尼，马来
            "bimg.akulaku.net",
            "dev-bimg.akulaku.net",
            "test-bimg.akulaku.net",
            "line8-user-experience-prod.oss-ap-southeast-5.aliyuncs.com",
            // 马来活动发布配置的背景图可能直接返回后端的图片使用域名
            "background-business-biz-service-prod.oss-ap-southeast-5.aliyuncs.com",
            // 欧洲
            "dev-bimg.wisecartapp.net",
            "test-bimg.wisecartapp.net",
        ],
        _a),
};
// 初始化webp参数
export function initWebpOptions(params) {
    options.isSupportWebp =
        typeof params.isSupportWebp === "boolean" ? params.isSupportWebp : isSupportWebp(params.req);
    options.dpr = typeof params.dpr === "number" ? params.dpr : getDpr(params.req);
    if (params.rem2px) {
        options.rem2px = params.rem2px;
    }
    if (params.cdnConfig) {
        options.cdnConfig = params.cdnConfig;
    }
}
// 获取webp参数
export function getWebpOptions() {
    return options;
}
/**
 * 校验cdn平台
 * @param host 域名
 */
export function checkCdnCloudPlatform(host) {
    var cdnConfig = options.cdnConfig;
    for (var key in cdnConfig) {
        var e = cdnConfig[key];
        if (e.includes(host)) {
            return key;
        }
    }
}
